import { Link } from "react-router-dom";
import { industries } from "@/data/industries";

export default function IndustriesGrid() {
  return (
    <section className="py-20 md:py-28 bg-[#F1F5F9]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl mb-14">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#00A651] mb-3">Industries</div>
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tighter text-[#1F1E4E]">
            Built for the way <em className="not-italic underline decoration-[#00A651] decoration-4 underline-offset-4">your industry</em> works.
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {industries.map((ind) => {
            const I = ind.icon;
            return (
              <Link
                key={ind.slug}
                to="/industries"
                data-testid={`industry-${ind.slug}`}
                className="bg-white rounded-2xl border border-slate-200 p-7 hover:-translate-y-1 hover:shadow-md transition-all group"
              >
                <div className="h-11 w-11 rounded-xl bg-[#1F1E4E] flex items-center justify-center mb-5">
                  <I className="h-5 w-5 text-[#00A651]" />
                </div>
                <div className="text-lg font-extrabold text-[#1F1E4E]">{ind.name}</div>
                <div className="text-sm text-slate-500 mt-2 leading-relaxed line-clamp-2">{ind.challenge}</div>
                <div className="mt-5 text-xs font-bold text-[#00A651] group-hover:underline">Explore solution →</div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
